export default __webpack_public_path__ + "images/Ice-Cream.48e7bb.jpg";